import { removeAccents } from '@/assets/scripts/validators'

const noSpecialCharacters = { '*': { validator: '[a-zA-Z0-9À-ž ]' } }
const noWhiteSpaces = { '*': { validator: '[^ ]' } }
const lettersOnly = { '*': { validator: '[a-zA-ZÀ-ž ]' } }

export const ACCOUNT_NUMBER = {
	mask: '(DW9{7} 9{2} 9{3}|9{9} 9{2} 9{3})',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const ACCOUNT_NIB = {
	mask: '9{4} 9{4} 9{11} 9{2}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const NBA_ORIGEM = {
	mask: '9{4} 9{4} 9{11} 9{2}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const ACCOUNTS_NIB_IBAN = {
    mask: '(9{9}|9{9} 9{2} 9{3}|AO06 9{4} 9{4} 9{4} 9{4} 9{4} 9{1})',
    definitions: { A: { validator: '[aA]', casing: 'upper' } },
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false,
    unmaskFn: value => {
        return value.replace(/\s+/g, '')
    }
}

export const IBAN_HOME = {
	mask: 'A{2}9{2}.9{4}.9{4}.9{4}.9{4}.9{4}.9{1}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const ACCOUNTS_NIB_IBAN_GENERIC = {
    mask: '(9{9}|9{9} 9{2} 9{3}|A{2}9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{1})',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const IBAN_AO = {
    regex: 'AO06 [0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4} [0-9]{1}',
    placeholder: '',
    showMaskOnHover: false,
    unmaskFn: value => {
        return value.replace(/\s+/g, '').toUpperCase()
    }
}

export const OURMASK_IBAN_AO = {
    initialValue: 'AO06',
    validatorFn: value => {
        const valueWithoutSpaces = value.replace(/\s+/g, '')
        const fullRegex = /^AO06[0-9]{0,25}$/

        return fullRegex.test(valueWithoutSpaces)
    },
    visualMask: value => {
        return value.replace(/\s+/g, '').toUpperCase().match(/.{1,4}/g)?.join(' ')
    },
    parseInputText: value => {
        if (value.length <= 4) return 'AO06'
        return removeAccents(value.toUpperCase().replace(/\s+/g, ''))
    }
}

export const WALLET = {
    mask: 'DW9{7} 9{2} 9{3}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const CARD_NUMBER = {
    mask: '9{4} 9{4} 9{4} 9{4}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const TMX_IBAN = {
    mask: '*{4} 9{4} 9{4} 9{4} 9{4} 9{4} 9{1}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const NUMBERS_ONLY = {
	mask: '9{*}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const NO_SPACES = {
	mask: '*{*}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false,
    definitions: noWhiteSpaces
}

export const LETTERS_ONLY = {
    mask: '*{*}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false,
    definitions: lettersOnly
}

export const PHONE_NUMBER = {
	mask: '9{14}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const PHONE_NUMBER_WITH_3_INDICATIVE = {
	mask: '(+9{3}) 9{3} 9{3} 9{3}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false
}

export const PHONE_NUMBER_INTERNATIONAL = {
	regex: '[0-9+ ]{1,24}',
	greedy: false,
	showMaskOnHover: false,
	showMaskOnFocus: false
}

export const NO_SPECIAL_CHARACTERS = {
    mask: '*{*}',
    greedy: false,
    showMaskOnHover: false,
    showMaskOnFocus: false,
    definitions: noSpecialCharacters
}

export const NIF = {
    mask: '9{9}a{2}9{3}',
    placeholder: '',
    showMaskOnHover: false,
    showMaskOnFocus: false,
    unmaskFn: value => {
        return value.replace(/\s+/g, '').toUpperCase()
    }
}
